module.exports = __webpack_public_path__ + "media/fall_2023_sweepstakes/national-scholarship-month-lockup-48811622.png";